import { AbstractSummaryProperties } from "@lib/titan2-slingo/dist/game/view/abstract/properties/AbstractSummaryProperties";
import { Modules } from "@lib/titan2/dist/game/Constants";
import { ControlConstants } from "@lib/titan2/dist/game/control/constant/ControlConstants";
import { VerticalLayout } from "@lib/titan2/dist/game/control/layout/VerticalLayout";
import { PanelProperties } from "@lib/titan2/dist/game/control/properties/PanelProperties";
import { SpineProperties } from "@lib/titan2/dist/game/control/properties/SpineProperties";
import { SpriteProperties } from "@lib/titan2/dist/game/control/properties/SpriteProperties";
import { TextFieldProperties } from "@lib/titan2/dist/game/control/properties/TextFieldProperties";
import * as PIXI from "pixi.js";
import { deepEquals } from "../../../utils/deepEquals";
import { GameTextUtil } from "../../../utils/GameTextUtil";
import { GameLang } from "../lang/GameLang";
import { GameFontStyle } from "../style/GameFontStyle";
import { GameStyle } from "../style/GameStyle";
import { GameSummaryCellProperties } from "./GameSummaryCellProperties";
/**
 * Game-specific properties for the post-game summary display.
 */
export class GameSummaryProperties extends AbstractSummaryProperties {
    setDefaultValues() {
        super.setDefaultValues();
        this.cellPanelProperties = new PanelProperties(new PIXI.Point(10, 380));
        this.cellPanelProperties.layout = new VerticalLayout(16);
        this.cellPanelProperties.size = new PIXI.Point(900, 500);
        this.cellPanelProperties.useMask = false;
        this.backgroundProperties = new SpriteProperties(GameStyle.GAME_SUMMARY, GameStyle.MODULE);
        this.overlaySpineProperties = new SpineProperties(GameStyle.SUMMARY_BACKGROUND, GameStyle.MODULE, new PIXI.Point(460, 386));
        this.slingoCellProperties = new GameSummaryCellProperties(null, GameLang.SLINGO_CELL, true);
        this.jokerCellProperties = new GameSummaryCellProperties(null, GameLang.RESULT_SCATTER, true);
        this.symbolWinCellProperties = new GameSummaryCellProperties(null, GameLang.RESULT_INSTANT, true);
        this.instantCellProperties = new GameSummaryCellProperties(null, GameLang.INSTANT_CELL, true);
        this.featureCellProperties = new GameSummaryCellProperties(null, GameLang.FEATURE_CELL, true);
        this.winAmountBackgroundProperties.position = new PIXI.Point(60, 760);
        this.position.set(0, 0);
        this.panelSpineProperties = new SpineProperties(GameStyle.SUMMARY_PANEL, Modules.GAME);
        this.titleFieldProperties.size = new PIXI.Point(600, 240);
        this.totalWinTitleFieldProperties = new TextFieldProperties(GameFontStyle.GAME_SUMMARY_TOTAL_WIN_TITLE, new PIXI.Point(0, -164), GameLang.TOTAL_WIN_TITLE, ControlConstants.CENTER, ControlConstants.CENTER, new PIXI.Point(450, 300));
        this.winAmountFieldProperties.size = new PIXI.Point(450, 140);
        this.winAmountFieldProperties.position.set(0, -75);
        GameTextUtil.centerProperties(this.titleFieldProperties);
    }
    equals(other) {
        return deepEquals(other, this);
    }
}
//# sourceMappingURL=GameSummaryProperties.js.map